import { Bot, Users, MessageCircle, Sparkles, type LucideIcon } from '../../../icons';
import { tChat } from '../../../lib/chat-i18n';

interface HeroCard {
  kind: 'ai' | 'group' | 'direct';
  Icon: LucideIcon;
  titleKey: string;
  descKey: string;
}

const CARDS: HeroCard[] = [
  { kind: 'ai', Icon: Bot, titleKey: 'chat.empty.card_ai_title', descKey: 'chat.empty.card_ai_desc' },
  { kind: 'group', Icon: Users, titleKey: 'chat.empty.card_group_title', descKey: 'chat.empty.card_group_desc' },
  { kind: 'direct', Icon: MessageCircle, titleKey: 'chat.empty.card_direct_title', descKey: 'chat.empty.card_direct_desc' },
];

/**
 * ChatEmptyHero (v2.11) — 대화 미선택 빈 상태.
 * 떠다니는 그라디언트 오브 배경 + 대화 종류 3종(AI/그룹/1:1) 카드 스태거 진입.
 * 정보·장식 전용 (카드 클릭 동작 없음 — 좌측 목록/새 대화 버튼 안내).
 * 이모지 금지 — 아이콘은 전부 인라인 SVG(lucide).
 */
export function ChatEmptyHero() {
  return (
    <div className="chat-empty-hero">
      <div className="chat-empty-orbs" aria-hidden="true">
        <span className="chat-empty-orb chat-empty-orb--1" />
        <span className="chat-empty-orb chat-empty-orb--2" />
        <span className="chat-empty-orb chat-empty-orb--3" />
      </div>

      <div className="chat-empty-head">
        <h2 className="chat-empty-title">{tChat('chat.empty.hero_title')}</h2>
        <p className="chat-empty-desc">{tChat('chat.empty.hero_desc')}</p>
      </div>

      <div className="chat-empty-cards">
        {CARDS.map((c, i) => (
          <div
            key={c.kind}
            className={`chat-empty-card chat-empty-card--${c.kind}`}
            style={{ animationDelay: `${120 + i * 110}ms` }}
          >
            <span className="chat-empty-card-icon" aria-hidden="true">
              <c.Icon size={22} />
              {c.kind === 'ai' && (
                <span className="chat-empty-card-spark">
                  <Sparkles size={11} />
                </span>
              )}
              {c.kind === 'group' && <span className="chat-empty-card-dot chat-empty-card-dot--a" />}
              {c.kind === 'group' && <span className="chat-empty-card-dot chat-empty-card-dot--b" />}
              {c.kind === 'direct' && (
                <span className="chat-empty-card-bubble">
                  <MessageCircle size={11} />
                </span>
              )}
            </span>
            <span className="chat-empty-card-title">{tChat(c.titleKey)}</span>
            <span className="chat-empty-card-desc">{tChat(c.descKey)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
